import { appConfig } from "../config/app.conf";

export const refugiosService = {
  getRefugios,
  getParkings,
  getParkingsByIds,
  getAllRoutes,
  routesBetweenRef,
};

const parkings = [
  {
    id: 2,
    name: "APARCAMIENTO DE LA SARRA (SALLENT DE GÁLLEGO)",
    coordenadas: ["42.79690105528666", "-0.3319369061595478"],
  },
  {
    id: 5,
    name: "APARCAMIENTO DE LA BARRAGE D’OSSOUE",
    coordenadas: ["42.756929054254016", "-0.09347064605443278"],
  },
  {
    id: 7,
    name: "APARCAMIENTO DE POUNTAS (PONT D’ESPAGNE)",
    coordenadas: ["42.85210988507631", "-0.13561854621754124"],
  },
  {
    id: 12,
    name: "APARCAMIENTO DEL BALNEARIO DE PANTICOSA",
    coordenadas: ["42.75915003041283", "-0.23437187584081234"],
  },
  {
    id: 14,
    name: "APARCAMIENTO DE FABRÈGES",
    coordenadas: ["42.87926194447939", "-0.39694290606457855"],
  },
  {
    id: 15,
    name: "APARCAMIENTO DE PLAN D’ASTE",
    coordenadas: ["42.88338117796204", "-0.27064420308136533"],
  },
];

async function getRefugios() {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  const rawData = await fetch(
    `https://api.${appConfig.api}/allRefuges/`,
    requestOptions
  );

  const request = await rawData.json();
  return request.data;
}

async function getParkings() {
  return new Promise(function(_delay) {
    setTimeout(_delay, 1500, parkings);
  });
}

async function getParkingsByIds(ids) {
  return new Promise(function(_delay) {
    const park = parkings.filter((p) => ids.includes(p.id));
    setTimeout(_delay, 1500, park);
  });
}

async function getAllRoutes() {
  const requestOptions = {
    method: "GET",
    // En Firefox no funciona
    //headers: { 'Content-Type': 'application/json' },
    mode: "cors",
  };

  const rawResponse = await fetch(
    `https://senderosturisticos.turismodearagon.com/vsp/api.rutas.php`,
    requestOptions
  );
  const content = await rawResponse.json();
  const data = await content;

  return data;
}

async function routesBetweenRef(origen, destino) {
  const requestOptions = {
    method: "GET",
    // En Firefox no funciona
    //headers: { 'Content-Type': 'application/json' },
    mode: "cors",
  };
  const url = `https://senderosturisticos.turismodearagon.com/vsp/api.rutas-refugios.php?origen=${origen}&destino=${destino}`;
  const rawResponse = await fetch(url, requestOptions);
  const content = await rawResponse.json();
  const data = await content;

  return data;
}
